import Chart from "react-apexcharts";
import { useEffect, useState } from "react";
import { API_RESPONSE } from "../../../utills/app-constant";
import { toastEmitter } from "../../../utills/utilities";
import { overallParticipationJobLevel } from "../../../services/api-services";
import generateChartImage from "./generateChartImage";
import Remark from "./Remark";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const OverallParticipationChartJobLevel = ({ selectedCompanyId, graphName }) => {
  const [rowData, setRowData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [remark, setRemark] = useState(""); // For remark text
  const [remarkId, setRemarkId] = useState(null); // For remarkId
  const [isAttempt, setIsAttempt] = useState(); // For remarkId
  const [departmentStats, setDepartmentStats] = useState([]);  
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        id: "job_level",
        type: "bar",
        stacked: true,
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "35%",
        },
      },
      colors: ["#28a745", "#ffc107","#dc3545"],
      xaxis: {
        categories: [],
      },
      yaxis: {
        min: 0,
        max: 60,
        tickAmount: 12,
        labels: {
          formatter: function (value) {
            return value;
          },
        },
      },
      dataLabels: {
        enabled: true,
      },
      legend: {
        position: "top",
        onItemClick: {
        toggleDataSeries: false, // ✅ prevent toggling
      },
      },
     
    },
  });

  // Fetch participation data
  const getAllParticipationDivisionData = async () => {
    setLoading(true);
    try {
      const response = await overallParticipationJobLevel(selectedCompanyId, graphName);
      if (response?.data?.responseCode === 200) {
        const remark = response?.data?.remark || "";
        const remarkId = response?.data?.remarkId || null;
        const isAttempt = response?.data?.isAttempt ?? 0;

        // Set remark and remarkId to state
        setRemark(remark);
        setRemarkId(remarkId);
        setIsAttempt(isAttempt)
        const departments = response?.data?.departmentStats || [];
        // Extract department names and participation data
        const departmentNames = departments.map(
          (department) => department.hierarchy
        );
        const Completed = departments.map(
          (department) => department.attemptedEmployee || 0
        );
        const In_Progress = departments.map(
          (department) => department.inProgressEmployee || 0
        );
        const Not_Started = departments.map(
          (department) => department.notAttemptedEmployee || 0
        );
        setChartData({
          series: [
            {
              name: "Completed",
              data: Completed,
            },
            {
              name: "In Progress",
              data: In_Progress,
            },
            {
              name: "Not Started",
              data: Not_Started,
            },

          ],
          options: {
            ...chartData.options,
            xaxis: {
              categories: departmentNames,
            },
          },
        });

        setRowData(response?.data);
        setDepartmentStats(response?.data?.departmentStats)

      } else if (response?.data?.responseCode === 404) {
        setRowData([]);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAllParticipationDivisionData();
  }, [selectedCompanyId]);


  useEffect(() => {
    if (chartData.series.some(series => series.data.some(val => val > 0))) {
     setTimeout(() => {
        generateChartImage('job_level', 'job_level', rowData?.remark);
      }, 100); // Delay to ensure the chart is mounted
    }
  }, [rowData, chartData.series]);  

   const exportDepartmentSummaryToExcel = (data, fileName = "Overall Participation (Job Level)") => {
  
      if (!data || !Array.isArray(data)) return;
      const title = ["Overall Participation (Job Level)"];
      const headers = [
        "Hierarchy Name",
        "Total Employees",
        "Not Attempted",
        "Attempted",
        "In Progress"
      ];
  
      const rows = data?.map(dept => [
        dept.hierarchy,
        dept.totalEmployee,
        dept.notAttemptedEmployee,
        dept.attemptedEmployee,
        dept.inProgressEmployee
      ]);
  
      const worksheet = XLSX.utils.aoa_to_sheet([
        title,
        [], // spacing row
        headers,
        ...rows
      ]);
  
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Department Summary");
  
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
  
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);
    };
  
  return (
    <>
    <div className="text-end">
        <button className="px-3 py-2 text-white bg-primary rounded border-0" onClick={() => exportDepartmentSummaryToExcel(departmentStats)}>Download Excel</button>
      </div>
       <div className="overallChart">
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <div className="chart12" data-heading=" Overall Participation (Job Level)" data-remark={remark}>
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          // height="300"
          width="850"
        />
        </div>
      )}
      <Remark selectedCompanyId={selectedCompanyId} graphName="OverallParticipationJobLevel" initialRemark={remark} remarkId={remarkId} isAttempt={isAttempt} setRemarkprops={setRemark}/>

    </div>
    </>
 
  );
};

export default OverallParticipationChartJobLevel;
